<template>

    <van-form class="container" @submit="onSubmit" >

        <div class="inner-container zx-fill-ticket-info">

            <div class="header f-s-b">
                <div class="header-item header-item-active theme-color-font">填写预约信息</div>
                <div class="header-item item-line " ></div>
                <div class="header-item">预约成功</div>
            </div>

            <div class="body g-big-tree-bg">
                
                <!-- 预约信息 -->
                <ul class="body-rander-item hide-input">

                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="预约日期"
                            :rules="[{ required: false }]"
                        />
                        <div class="right-control g-b-500 f-s-b" v-touch:tap.prevent="onChangeDate">
                            <span>{{getChooseDate.date}}</span>
                            <i class="iconfont iconjiantouarrow487 icon-size"></i>
                        </div>
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="预约时间"
                            :rules="[{ required: false }]"
                        />
                        <div class="right-control g-b-500 f-s-b" v-touch:tap.prevent="onChangeTime">
                            <!-- <span>{{columns[chooseTimeAcitve]}}</span> -->
                            <span>{{getChooseDate.time[chooseTimeAcitve]}}</span>
                            <i class="iconfont iconjiantouarrow487 icon-size"></i>
                        </div>
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="团队人数"
                            :rules="[{ required: false }]"
                        />
                        <div class="right-control number-control f-s-b g-b-500">
                            <i v-touch:tap.prevent="onChangeNumber('teamNumer',false)" class="iconhebei theme-color-font iconjianhao number-icon-size"></i>
                            <span class="number-box f-c g-black-color g-b-500">{{teamNumer}}</span>
                            <i v-touch:tap.prevent="onChangeNumber('teamNumer',true)" class="iconhebei theme-color-font iconjiahao number-icon-size"></i>
                        </div>
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="讲解员"
                            :rules="[{ required: false }]"
                        />
                        <div class="right-control number-control f-s-b g-b-500">
                            <!-- <i v-touch:tap.prevent="onChangeNumber('narratorNumber',false)" class="iconhebei theme-color-font iconjianhao number-icon-size"></i> -->
                            <!-- <span class="number-box f-c g-black-color g-b-500">{{narratorNumber}}</span> -->
                            <span class=" f-c g-black-color g-b-500">{{narratorNumber}}</span>
                            <!-- <i v-touch:tap.prevent="onChangeNumber('narratorNumber',true)" class="iconhebei theme-color-font iconjiahao number-icon-size"></i> -->
                        </div>
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="讲解员"
                            :rules="[{ required: false }]"
                        />
                        <div class="right-control g-b-500 f-s-b" v-touch:tap.prevent="onChangeLanguage">
                            <!-- <span class="">{{ radio === '1' ? '中文':'English'}}</span> -->
                            <span class="">{{ getLanguage.name }}</span>
                            <i class="iconfont iconjiantouarrow487 icon-size"></i>
                        </div>
                    </li>

                </ul>

                <div class="contacts-title-box f-s-b g-b-500">
                    <div>
                        <i class="iconhebei iconren2 icon-size theme-color-font"></i>
                        <span>预约人</span>
                    </div>
                    <div v-touch:tap.prevnt="routerPage" class="look-narrators">查看讲解员</div>
                </div>

                <ul class="body-rander-item explain-home-info-input">
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.name"
                            required
                            :name="`name`"
                            :border="false"
                            label="姓名"
                            placeholder="请输入联系人姓名"
                            :rules="[{ required: true, message: '请正确填写联系人姓名', validator: checkName }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.phone"
                            required
                            type="tel"
                            maxlength="11"
                            name="phone"
                            :border="false"
                            label="手机号"
                            placeholder="请输入联系人手机号"
                            :rules="[{ required: true, message: '请正确填写联系人手机号', validator: checkPhone }]"
                        />
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.id"
                            required
                            name="id"
                            :border="false"
                            label="证件号"
                            placeholder="请输入联系人证件号"
                            :rules="[{ required: true, message: '请正确填写联系人证件号', validator: checkId }]"
                        />
                    </li>
                </ul>

                <ul class="body-rander-item"></ul>

                <ul class="body-container ">
                    <li class="title">温馨提示</li>
                    <van-image 
                        class="body-iamge"
                        lazy-load
                        fit="contain"
                        :src="imageList[0]" 
                    />
                    <li class="item time" v-if="domHtml">
                        <div v-html="domHtml"></div>
                    </li>
                    <li class="item time" v-else>
                        暂无温馨提示
                    </li>

                    <!-- <li class="small-title g-b-500">温馨提示</li> -->
                    <!-- <li class="item time">
                        门票讲解仅限馆区内指定区域讲解。
                    </li>
                    <li class="item time">
                        预约讲解员前请确认是否已预约门票。
                    </li>
                    <li class="item time">
                        预约讲解员仅限团队预约，最低10人起约。
                    </li>
                    <li class="item time">
                        预约后请提前15分钟到达现场。
                    </li>
                    <li class="item time">
                        如行程有变，请提前一天取消预约，如预约后未入馆则加入博物馆黑名单，一年内禁止预约讲解员。
                    </li> -->

                </ul>
            </div>

            <div class="foot f-c">
                <!-- <div class="btn f-c">确认预约</div> -->
                <van-button class="btn f-c" :class="flag? '':'gray-color'" block type="info" native-type="submit">
                    {{btnTxt}}
                </van-button>
            </div>

            <van-calendar 
                v-model="show" 
                @confirm="onConfirm" 
                @select="selectDate" 
                safe-area-inset-bottom	
                position="top"
                color="#4282FF"
                title="选择预约日期"
                :default-date="defaultDate"	
                :show-confirm="false"
                :formatter="formatter"
            />

            <van-popup 
                position="bottom"
                v-model="timeShow"
                round
                :style="{ height: '50%' }"
                :close-on-popstate="true"
                :safe-area-inset-bottom="true"
            >

                <!-- <van-datetime-picker
                    v-model="currentTime"
                    type="time"
                    :min-hour="10"
                    :max-hour="20"
                    :formatter="timeFormatter"
                /> -->

                <van-picker 
                    show-toolbar
                    title="选择预约时间"
                    :columns="getChooseDate.time" 
                    @cancel="onChangeTime" 
                    @confirm="onChangeTimeSuccess"
                    :default-index="chooseTimeAcitve"
                />
                    <!-- @change="onChangeTimeValue"  -->
            </van-popup>

            <van-popup
                closeable
                close-icon="close"
                v-model="languageShow"
                position="bottom"
                round
                :style="{ height: 'auto;' }"
                :close-on-popstate="true"
                :safe-area-inset-bottom="true"
            >
                <van-radio-group 
                    v-model="radio"
                    class="language-box f-c"
                >
                    <van-cell-group class="language">

                        <van-cell 
                            v-for="(item, index) in languageList" :key="index"
                            class="language-row f-s-b" 
                            :title="item.name" 
                            clickable 
                            @click="radio = item.id">
                            <van-radio slot="right-icon" :name="item.id" />
                        </van-cell>

                        <!-- <van-cell class="language-row f-s-b" title="中文" clickable @click="radio = '1'">
                            <van-radio slot="right-icon" name="1" />
                        </van-cell>

                        <van-cell class="language-row f-s-b" title="English" clickable @click="radio = '2'">
                            <van-radio slot="right-icon" name="2" />
                        </van-cell> -->

                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <div hidden style="width:0;height:0;">{{getUserInfo}}</div>

        </div>

    </van-form>

</template>

<script>
    import http from '@js/http-zyz.js';
    import {
        checkCanOrderUrl,
        getRuleInfoUrl,
        getDictionaryListUrl,
        saveaGorderUrl,
    } from '@js/volunteerUrl.js';
    import util from '@util';
    import { 
        Field,
        Calendar,
        Popup,
        DatetimePicker,
        RadioGroup, 
        Radio,
        Cell, 
        CellGroup,
        Picker,
        Form, 
        Button,
    } from 'vant';
    export default {
        data() {
            return {
                phonePattern: /^1[3456789]\d{9}$/,
                idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                imageList:[require('@image/home/21321321.png'),],
                name:'',
                // date: util.formatTime(new Date(), "yyyy-MM-dd"),
                show: false,
                timeShow: false,
                languageShow: false,
                radio: '1',
                narratorNumber:1,
                teamNumer:10,
                contactsInfo: {
                    name: '',
                    phone: '',
                    id: '',
                },
                // currentTime: '12:00',


                //  能否预约
                flag: false,
                btnTxt: '停止预约',
                domHtml:'',
                //  控制人员和讲解员的比例数
                proportionNumebr: 0,
                dateList: [],
                defaultDate: new Date(),
                chooseDate: '',
                chooseTime: '',
                chooseTimeAcitve: 0,
                isChangeDateFlag: false,
                languageList: [
                    {
                        name: '中文',
                        id: '1',
                    },
                    // {
                    //     name: 'English',
                    //     id: 2,
                    // },
                ]
            }
        },
        created() {
            this.checkCanOrder();
            this.getLanguageList();
        },
        methods: {
            checkCanOrder(){
                http.get(checkCanOrderUrl)
                    .then(res=>{
                        var {
                            data: {
                                data = false,
                            }
                        } = res;
                        if(data === true){
                            this.flag = data;
                            this.btnTxt = "确认预约"
                            this.getRuleInfo();
                        }
                    })
            },
            getLanguageList(){
                http.post(getDictionaryListUrl, { code: 'ag_order_language' })
                    .then(res=>{
                        var {
                            data:{
                                data: array = [],
                                success = false
                            },
                        } = res;
                        if(success === true){
                            this.languageList = [];
                            array.map((item, index)=>{
                                this.languageList.push({
                                    name: item.name,
                                    id: item.code,
                                    index,
                                })
                            })
                        }
                    })
            },
            getRuleInfo(){
                http.get(getRuleInfoUrl)
                    .then(res=>{
                        var {
                            data: {
                                data: {
                                    comment,
                                    number,
                                    dateList = [],
                                },
                                success = false 
                            },
                        } = res;
                        if(success){
                            this.proportionNumebr = number;
                            this.domHtml = comment;
                            this.dateList = dateList;
                            //  设置初始选中的 日期 和 时间 修改日历选中的 默认日期
                            if(dateList.length>0){
                                var obj = dateList[0];
                                this.chooseDate =  obj.date;
                                if(obj.time.length>0){
                                    this.chooseTime =  obj.time[0];
                                }
                                this.defaultDate = new Date(obj.date)
                            }else{
                                this.flag = false;
                                this.btnTxt = "暂无可预约时段"
                            }
                        }
                    })
            },
            routerPage(){
                this.$router.push({ name: 'narrator'})
            },
            onSubmit(values) {
                if(!this.flag) return;
                if(values) {
                    var data = {
                        orderDate: this.chooseDate,
                        orderTime: this.chooseTime,
                        // orderTime: '09:30',
                        personNumber: this.teamNumer,
                        guideNumber: this.narratorNumber,
                        language: this.radio,
                        userName: this.contactsInfo.name,
                        idcard: this.contactsInfo.id,
                        phone: this.contactsInfo.phone,
                    }
                    // console.log(data)
                    this.commitData(data);
                }
            },
            commitData(data){
                http.post(saveaGorderUrl, data)
                    .then(res=>{
                        // console.log(res)
                        var {
                            data: {
                                data: {
                                    agOrderId: id = '',
                                },
                                success = false
                            }
                        } = res;
                        if(success){
                            this.$router.push({ name: 'narratorSuccess', query: { id }})
                        }
                    })
            },
            onConfirm(date) {
                if(!this.isChangeDateFlag){
                    this.$toast('请选择可预约时间进行预约');
                    this.defaultDate = new Date(this.chooseDate)
                    return
                }
                this.show = false;
                this.chooseDate = util.formatTime(new Date(date), "yyyy-MM-dd");
                this.chooseTimeAcitve = 0;
                if(this.getChooseDate.time.length>0){
                    this.chooseTime = this.getChooseDate.time[0];
                }
            },
            selectDate(date){
                this.isChangeDateFlag = false;
                var array = this.dateList,
                    tempDate = util.formatTime(date, "yyyy-MM-dd");
                for (let index = 0, len = array.length; index < len; index++) {
                    let element = array[index];
                    if(element.date === tempDate){
                        this.isChangeDateFlag = true;
                        break;
                    }
                }
            },
            // onChangeTimeValue(picker, value, index) {
            //     // this.$toast(`当前值：${value}, 当前索引：${index}`);
            //     // this.chooseTimeAcitve = index;
            //     // console.log(index)
            //     // this.onChangeTime();
            // },
            onChangeTimeSuccess(value,index){
                this.chooseTimeAcitve = index;
                this.chooseTime = value;
                this.onChangeTime();
            },
            onChangeLanguage() {
                this.languageShow = !this.languageShow;
            },
            onChangeTime() {
                this.timeShow = !this.timeShow;
            },
            onChangeDate() {
                this.show = true;
            },
            checkName(v){
                return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v)
                // return v === ""? false : true;
            },
            onChangeNumber(type = 'narratorNumber',flag = true){
                return ()=>{
                    if(flag){
                        this.$data[type]++
                    }else{
                        if(this.$data[type]>1) {
                            this.$data[type]--;
                        }
                    }
                    var value = this.teamNumer / (this.proportionNumebr || 10);
                    value = Math.ceil(value)
                    this.narratorNumber = value || 1;
                }
            },
            checkPhone(v){
                return this.phonePattern.test(v)
                // return new Promise(resolve => {
                //     this.$toast.loading({
                //         forbidClick: true,
                //         message: '验证中...'
                //     });
                //     setTimeout(() => {
                //         this.$toast.clear();
                //         resolve(this.phonePattern.test(v));
                //     }, 700);
                // });
            },
            checkId(v){
                return this.idPattern.test(v);
            },
            formatter(day) {
                this.dateList.map(item=>{
                    let tempDate = util.formatTime(new Date(day.date), "yyyy-MM-dd");
                    if(String(tempDate) === String(item.date)){
                        day.bottomInfo = '可预约';
                    }
                })
                // const month = day.date.getMonth() + 1;
                // const date = day.date.getDate();
                // if (month === 5) {
                //     if (date === 1) {
                //     day.topInfo = '劳动节';
                //     day.bottomInfo = '劳动节';
                //     day.text = '劳动节';
                //     } else if (date === 4) {
                //     day.topInfo = '五四青年节';
                //     } else if (date === 11) {
                //     day.text = '今天';
                //     }
                // }
                // if (day.type === 'start') {
                //     day.bottomInfo = '入住';
                // } else if (day.type === 'end') {
                //     day.bottomInfo = '离店';
                // }
                return day;
            },
            timeFormatter(type, val){
                if (type === 'hour') {
                    return `${val}时`;
                } else if (type === 'minute') {
                    return `${val}分`
                }
                return val;
            }
        },    
        computed: {
            getChooseDate(){
                let obj = {
                    date: '暂无日期可选',
                    time: ['暂无时间段可以选']
                };
                let array = this.dateList;
                for (let index = 0 , len = array.length; index < len; index++) {
                    let element = array[index];
                    if(element.date === this.chooseDate){
                        return element;
                    }
                }
                return obj;
            },
            getUserInfo(){
                let info = this.$store.state.userInfo.info || false;
                if(info){
                    this.contactsInfo.name = info.userName;
                    this.contactsInfo.phone = info.phone;
                    this.contactsInfo.id = info.idcard;
                }
                return info;
            },
            getLanguage(){
                let obj = {
                    name: ""
                }
                this.languageList.map(item=>{
                    if(item.id === this.radio){
                        obj = item;
                    }
                })
                return obj;
            }
        },  
        components:{
            [Field.name]: Field,
            [Calendar.name]: Calendar,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker,
            [RadioGroup.name]: RadioGroup, 
            [Radio.name]: Radio,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Picker.name]: Picker,
            [Form.name]: Form,
            [Button.name]: Button,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 50px)" !important;
        // padding-bottom: 50px;

        .inner-container{
            height: auto;
            .header{
                position: relative;
                padding: 0 35px 0 65px;
                box-sizing: border-box;
                background-color: #ffffff;
                height: 56px;
                color: #9C9C9C;
                .header-item{
                    white-space: nowrap;
                    width: auto;
                    position: relative;
                    text-align: center;
                }
                .item-line{
                    width: 30%;
                    border-bottom: 1PX dotted #9C9C9C;
                }
                .header-item-active{
                    margin-left: -25px;
                    &::before{
                        background-color: #4282FF;
                        content: '';
                        border-radius: 2px;
                        height: 5px;
                        width: 65px;
                        position: absolute;
                        bottom: -10px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
            }
    
            .body{
                margin-bottom: 10px;
                padding: 7px;
                .body-rander-item{
                    overflow: hidden;
                    border-radius:5px;
                    box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                    margin-bottom: 7px;
                    .row-box{
                        position: relative;
                        box-sizing: border-box;
                        height: 50px;
                        padding: 0 12px;
                        background-color: #ffffff;
                        &:last-child{
                            .item-row{
                                border: 0;
                            }
                        }
                        .item-row{
                            border-bottom: .5px solid #CBCBCB;
                            height: 100%;
                            background-color: transparent;
                            font-size: 14px;
                        }
                        .right-control{
                            color: #9599A2;
                            position: absolute;
                            top: 50%;
                            overflow: hidden;
                            transform: translateY(-50%);
                            left: 90px;
                            right: 12px;
                            .icon-size{
                                &::before{
                                    font-weight: 500;
                                }
                            }
                        }
                        .number-control{
                            justify-content: flex-start;
                            .number-box{
                                margin: 0 10px;
                                display: inline-flex;
                                vertical-align: top;
                                width:65px;
                                height:22px;
                                box-sizing: border-box;
                                border:1px solid rgba(212,212,212,1);
                            }
                            .number-icon-size{
                                &::before{
                                    font-size: 20px;
                                    font-weight: 500;
                                }
                            }
                        }
                    }
                }
                .body-container{
                    position: relative;
                    border-radius:5px;
                    overflow: hidden;
                    box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                    background-size: 118px 142px;
                    background-repeat: no-repeat;
                    background-position: right 70%;
                    background-image: url('../../lib/image/home/567.png');
                    background-color:rgba(255,255,255,1);
                    box-sizing: border-box;
                    width: 100%;
                    padding: 14px 30px;
                    font-size: 12px;
                    color: #565656;
                    height: auto;
                    &{
                        .item:last-child{
                            margin: 0;
                        }
                    }
                    .title{
                        text-align: center;
                        color: #242424;
                        font-size: 16px;
                    }
                    .small-title{
                        font-size: 14px;
                        color: #565656;
                    }
                    .body-iamge{
                        width: 100%;
                        margin: 10px 0;
                    }
                    .item{
                        margin-bottom: 10px;
                    }
                    .time{
                        padding-left: 9px;
                        letter-spacing: 1px;
                    }
                }
                .contacts-title-box{
                    padding-left: 12px;
                    height: 50px;
                    font-size: 14px;
                    color: #555555;
                    // justify-content: flex-start;
                    .icon-size{
                        margin-right: 5px;
                        &::before{  
                            // font-size: 22px;
                        }
                    }
                    .look-narrators{
                        border: 0;
                        padding: 3px 6px;
                        font-size: 15px;
                        color:rgba(255,255,255,1);
                        background:rgba(92,162,253,1);
                        border-radius:3px;
                    }
                }
            }
    
            .foot{
                background-color: #f0f1f4;
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                height: 50px;
                .btn{
                    border: 0;
                    font-size: 15px;
                    color:rgba(255,255,255,1);
                    width:332px;
                    height:50px;
                    background:rgba(92,162,253,1);
                    border-radius:12px;
                }
            }
    
            .language-box{
                box-sizing: border-box;
                padding: 50px;
                flex-direction: column;
                .language{
                    width: 100%;
                }
                .language-row{
                    width: 100%;
                    height: 40px;
                }
            }
        }

    }
</style>